import { render, staticRenderFns } from "./ClientCoupon.vue?vue&type=template&id=25ffabd6&scoped=true"
import script from "./ClientCoupon.vue?vue&type=script&lang=js"
export * from "./ClientCoupon.vue?vue&type=script&lang=js"
import style0 from "./ClientCoupon.vue?vue&type=style&index=0&id=25ffabd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ffabd6",
  null
  
)

export default component.exports